/** Yeni tip eklerken SONA ekle — backend DbEnums.CustomerIdentityDocumentType ile birebir aynı olmalı. */
export enum CustomerIdentityDocumentType {
  /** T.C. Kimlik Kartı — ön/arka yüzün AYRI yüklenebildiği tek belge türü. */
  Tckn = 1,
  /** Geriye dönük uyumluluk için tutulur; artık seçilebilir listede YOK (bkz. aşağı). */
  Vkn = 2,
  Passport = 3,
  IkametBelgesi = 4,
  CalismaIzni = 5,
}

/**
 * Seçilebilir liste — rakip ürün benchmark'ındaki (sarraf.pro) gerçek kişi kimlik
 * tespiti belge türleriyle birebir aynı. Vkn kasıtlı olarak YOK: gerçek kişi kimlik
 * tespitinde vergi numarası değil kimlik belgesi türü sorulur.
 */
export const CUSTOMER_IDENTITY_DOCUMENT_TYPE_OPTIONS: { value: CustomerIdentityDocumentType; text: string }[] = [
  { value: CustomerIdentityDocumentType.Tckn, text: 'T.C. Kimlik Kartı' },
  { value: CustomerIdentityDocumentType.Passport, text: 'Pasaport' },
  { value: CustomerIdentityDocumentType.IkametBelgesi, text: 'İkamet Belgesi' },
  { value: CustomerIdentityDocumentType.CalismaIzni, text: 'Çalışma İzni' },
];
